import { APIObject } from "@/services/api/types";
import { PartnerStatus } from "../types";

export enum PartnerContactColumn {
  FULL_NAME = "fullName",
  // The linked partner display name — this is the table column, so sort, group
  // and filter all resolve on the same field the cell renders.
  PARTNER_NAME = "partnerName",
  STATUS = "status",
  JOB_TITLE = "jobTitle",
  EMAILS = "emails",
  WORK_PHONE = "workPhone",
  MOBILE_PHONE = "mobilePhone",
  COUNTRY = "country",
  STATE_REGION = "stateRegion",
  CITY = "city",
  POSTAL_CODE = "postalCode",
  ADDRESS = "address",
  CREATED_AT = "createdAt",
  // The raw partner FK. Not a table column (see partnerContactColumnKeys) —
  // it is the filter key used to scope contacts to a single partner.
  PARTNER = "partner"
}

interface PartnerContactData extends APIObject {
  firstName: string | null;
  lastName: string | null;
  partner: string | null;
  partnerName: string | null;
  status: PartnerStatus | null;
  jobTitle: string | null;
  emails: string[] | null;
  workPhone: string | null;
  mobilePhone: string | null;
  country: string | null;
  stateRegion: string | null;
  city: string | null;
  postalCode: string | null;
  address: string | null;
  createdAt: string | null;
}

interface PartnerContactsPage {
  partners_contacts: PartnerContactData[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export type { PartnerContactData, PartnerContactsPage };
